/* eslint no-mixed-operators: 0 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Textarea,
} from '@cargomatic/ui';
import _ from 'underscore';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import { CargomaticDropzone, DROPZONE_VARIANTS } from 'components/v2/Dropzone';
import { ACCEPTED_FILE_TYPES } from 'config/accepted-file-types';
import { withTranslation } from 'react-i18next';
import ViewAccessorialRequestDocumentRequirements from 'components/modules/shipments/accessorials/ViewAccessorialDocumentRequirements';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import DocumentPreview from './stops/DocumentPreview';

class DocumentUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      notes: '',
    };
  }

  upload = () => {
    const {
      accessorial,
      accessorial: { id },
      onHide,
      t,
    } = this.props;

    const name = t('ACCESSORIAL_DOC_NAME', {
      accessorialName: accessorial.accessorial,
    });
    ShipmentsActionCreators.uploadAccessorialDocument(
      id,
      this.state.files,
      name,
      this.state.notes,
      accessorial.accessorial,
    );
    onHide();
  };

  handleFile = (file) => {
    this.setState((previousState) => {
      return {
        files: [...previousState.files, ...file],
      };
    });
  };

  handleRemoveFile = (id) => {
    const { files } = this.state;
    const newFiles = _.without(files, _.findWhere(files, { preview: id }));
    this.setState({ files: newFiles });
  };

  handleNoteChange = (e) => {
    this.setState({ notes: e.target.value });
  };

  renderPreview() {
    if (!this.state.files.length) {
      return null;
    }

    const filePreviews = this.state.files.map((file, index) => {
      return (
        <div key={index} className="px-4 py-2">
          <DocumentPreview
            url={file.preview}
            type={file.type}
            displayInGridView
            renderDownloadableImage
            handleRemove={this.handleRemoveFile}
          />
        </div>
      );
    });

    return (
      <div className="mb-4">
        <div className="grid-3-x-3">{filePreviews}</div>
      </div>
    );
  }

  renderUploader() {
    const { t, shipment, accessorial } = this.props;
    if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
      return (
        <ViewAccessorialRequestDocumentRequirements
          containerClassName="mb-4 p-2"
          accessorial={{ ...accessorial, slug: accessorial.accessorial_type }}
          shipper={shipment?.shipper?._id}
          shipment={shipment}
          isExistingAccessorialRequest={true}
        />
      );
    }
    return (
      <div>
        {this.state.files.length ? this.renderPreview() : null}
        <CargomaticDropzone
          variant={DROPZONE_VARIANTS.BORDERED}
          onDrop={this.handleFile}
          multiple
          accept={ACCEPTED_FILE_TYPES}
        >
          <div>{t('CLICK_OR_DRAG_TO_UPLOAD_FILE')}</div>
        </CargomaticDropzone>
      </div>
    );
  }

  renderFooter() {
    const { t, onHide } = this.props;
    if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
      return <Button onClick={onHide}>{t('CLOSE')}</Button>;
    }
    return (
      <Button onClick={this.upload} disabled={!this.state.files.length}>
        {t('UPLOAD')}
      </Button>
    );
  }

  render() {
    const { show, onHide, accessorial, t } = this.props;
    return (
      <Dialog
        open={show}
        onOpenChange={(open) => {
          if (!open) onHide();
        }}
      >
        <DialogContent className="max-w-lg max-h-[90vh] p-0 gap-0 flex flex-col overflow-hidden">
          <DialogHeader className="px-6 pt-5 pb-4 border-b border-border shrink-0">
            <DialogTitle>
              {`${t('ADD_ACCESSORIAL_DOCUMENTS')} - ${accessorial.accessorial}`}
            </DialogTitle>
          </DialogHeader>
          <div className="flex-1 overflow-y-auto px-6 py-4">
            {this.renderUploader()}
            <div className="mt-3">
              <Label className="mb-2">{t('NOTE', { count: 2 })}</Label>
              <Textarea
                rows={4}
                className="resize-none w-full"
                value={this.state.notes}
                onChange={this.handleNoteChange}
              />
            </div>
          </div>
          <DialogFooter className="px-6 py-4 border-t border-border shrink-0">
            {this.renderFooter()}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}

DocumentUpload.propTypes = {
  show: PropTypes.bool,
  accessorial: PropTypes.object,
  onHide: PropTypes.func,
};

DocumentUpload.defaultProps = {
  show: false,
  accessorial: {},
  onHide: () => {
    return null;
  },
};

export default withTranslation()(DocumentUpload);
